import React from "react";
import PDFPod from "@/components/PDFPod.jsx";
import CertProficiencyPod from '~/components/CertProficiencyPod.jsx';
import CertificationExamPod from '~/components/CertificationExamPod.jsx';
import CertificationPod from '~/components/CertificationPod.jsx';
import MainLanding from "~/features/MainLanding.jsx";

const components = {
    MainLanding,
};

const ComponentNotFound = ({ name }) => <span>Component {name} was requested but not registered.</span>;

const PodRenderer = ({ podule, ...props }) => {
    switch (podule.type) {
        case 'component':
            const Component = components[podule.itself];
            return Component ? <Component podule={podule} {...props} /> : <ComponentNotFound name={podule.itself} />;
        case 'pdf':
            return <PDFPod podule={podule} {...props} />;
        case 'proficiency-component':
            return <CertProficiencyPod podule={podule} {...props} />;
        case 'certification-exam-component':
            return <CertificationExamPod podule={podule} {...props} />;
        case 'certification':
            return <CertificationPod podule={podule} {...props} />;
        default:
            return <>this is a pod</>;
    }
};

export default PodRenderer;